import { useCallback } from "react";
import { useApi } from "../services/api";

// Changing a password goes to Flask (POST /api/auth/password), which checks
// the current password against Logto and only then sets the new one, so a
// session left open in an unattended browser is not enough to take the
// account over. See backend/session.py.

export class ChangePasswordError extends Error {}

export const useChangePassword = () => {
  const { apiFetch } = useApi();

  return useCallback(
    async (currentPassword, newPassword) => {
      let response;
      try {
        response = await apiFetch("/api/auth/password", {
          method: "POST",
          body: JSON.stringify({ currentPassword, newPassword }),
        });
      } catch {
        throw new ChangePasswordError(
          "Could not reach the server. Check your connection and try again."
        );
      }
      if (!response.ok) {
        const body = await response.json().catch(() => null);
        throw new ChangePasswordError(
          body?.message ?? `The server returned ${response.status}.`
        );
      }
    },
    [apiFetch]
  );
};
